
import Swiper from 'https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js';

class EducacaoAntirracista
{
	Carrosel()
	{
		const swiper = new Swiper('#EducacaoAntirracistaSwiper', 
		{
			slidesPerView: 'auto',
			spaceBetween: 20,
			speed: 1000,
			navigation: false,
			breakpoints: 
			{
				0: {
					spaceBetween: 14,
					simulateTouch: true, 
					loop: true,
					pagination: {
						el: '#EducacaoAntirracistaSwiper .swiper-pagination',
						clickable: true,
					},
				},
				480: {
					simulateTouch: true, 
					loop: true,
					pagination: {
						el: '#EducacaoAntirracistaSwiper .swiper-pagination',
						clickable: true,
					},
				},
				1280: {
					loop: false,
					simulateTouch: false, 
					pagination: false,
				}
			}
		});
	}

	AccordeonListaDetalhe()
	{
		$('#CCListaConteudoEducaRacista ul.ListaFiltroPosts li .wrapItem').each(function(index)
		{
			const parent 	= $(this);
			const button 	= parent.find('.info').find('.accordion').find('button.accordeonAntirracistaTaxButton');
			const detalhes 	= parent.find('.info').find('.accordion').find('.accordeonAntirracistaTaxList');

			if (index === 0) {
				button.toggleClass('Opened');
				detalhes.toggleClass('Opened');
			}

			button.click(function(e)
			{
				e.preventDefault();

				$(this).toggleClass('Opened');
				detalhes.toggleClass('Opened');
			})
		})

	}

	init(options)
	{
		const self = this;

		if ($("#EducacaoAntirracistaSwiper").length > 0)
    	{
			self.Carrosel();
		}

		if($('#CCListaConteudoEducaRacista ul.ListaFiltroPosts').length > 0)
		{
			self.AccordeonListaDetalhe();
		}

		$(window).resize(function()
		{
			if ($("#EducacaoAntirracistaSwiper").length > 0)
			{
				self.Carrosel();
			}
		});
	}
}

export default EducacaoAntirracista;